<template>
    <div class="im">
        <!-- 右侧聊天窗口 -->
        <div class="dialogue-content">
            <div class="drag-handle">
                {{ dmName }}
            </div>
            <img class="close" src="@/assets/close.png" @click="chatModalToggle" alt="关闭" />
            <!-- 消息列表 -->
            <div class="message-list" ref="messageList" @scroll="handleScroll">
                <div v-if="isLoadingMore" class="loading-more">加载中...</div>
                <div
                    v-for="msg in sortedMessages"
                    :key="msg.id"
                    class="message-item"
                    :class="{ 'message-left': msg.flow == 'in', 'chat-time-box': msg.payload.description === 'time' }"
                >
                    <div v-if="msg.type == 'TIMTextElem'" class="text">{{ msg.payload.text }}</div>
                    <img v-else-if="msg.type === 'TIMImageElem'" :src="msg.payload.imageInfoArray[0].imageUrl" class="image-message" />
                    <div v-else-if="msg.type === 'TIMCustomElem' && msg.payload.description === 'customer_card'">
                        <div v-if="isValidJson(msg.payload.data)" class="card-box">
                            <div class="service-avatar">
                                <img src="@/assets/image/service-avatar.png" alt="客服头像" />
                                {{ JSON.parse(msg.payload.data).nickname }}
                            </div>
                            <!--                            <div class="go-chat" @click="goChat(msg.payload.data)">去聊天</div>-->
                        </div>
                        <div v-else>客服卡片信息</div>
                    </div>

                    <!-- 小程序发来的图片-->
                    <div v-if="msg.type === 'TIMCustomElem' && msg.payload.description === 'im_image'">
                        <div class="img-wrap">
                            <el-image
                                :src="encodeURI(JSON.parse(msg.payload.data).url)"
                                class="message-image"
                                fit="contain"
                                :preview-src-list="[encodeURI(JSON.parse(msg.payload.data).url)]"
                                alt="图片类型"
                            ></el-image>
                        </div>
                    </div>

                    <!-- 时间         -->
                    <div v-if="msg.type === 'TIMCustomElem' && msg.payload.description === 'time'" class="time-box">
                        {{ formatMessageTime(msg) }}
                    </div>

                    <div class="customer-ele-keFu" v-if="msg.type === 'TIMCustomElem' && msg.payload.description === 'KeFu'">
                        <div v-if="isValidJson(msg.payload.data)" class="card-box">
                            <div class="menu-box">
                                <div class="menu-wrap">
                                    <p class="mune-title">
                                        <strong>{{ JSON.parse(msg.payload.data).title }}</strong>
                                    </p>
                                    <!--                                <div class="menu-list">-->
                                    <!--                                    <div>-->
                                    <!--                                        <div v-for="(item,idx) in JSON.parse(msg.payload.data).query" :key="idx"-->
                                    <!--                                             :class="{'next': item.text}" class="item2 border" @click="onClickItem(item)">-->
                                    <!--                                            <span class="ellipsis" :title="item.title">{{ item.title }}</span>-->
                                    <!--                                        </div>-->
                                    <!--                                    </div>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="msg.type === 'TIMFileElem'">
                        <div v-if="getFileType(msg.payload.fileName) === 'image'" class="img-wrap">
                            <el-image
                                :src="msg.payload.fileUrl"
                                class="message-image"
                                :lazy="false"
                                fit="contain"
                                :preview-src-list="[msg.payload.fileUrl]"
                                alt="图片类型"
                            ></el-image>
                        </div>
                    </div>
                    <div v-if="msg.payload.description !== 'time'" class="avatar-box">
                        <img
                            class="avatar"
                            v-if="msg.flow == 'out'"
                            :src="userAvatar || 'https://static.zilieai.com/static/img/avatar/man.png'"
                            alt="头像"
                        />
                        <img class="avatar" v-if="msg.flow == 'in'" src="@/assets/image/service-avatar.png" alt="客服头像" />
                    </div>
                </div>
            </div>

            <!-- 消息输入框 -->
            <div class="message-box">
                <div class="function-bar">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :auto-upload="false"
                        :show-file-list="false"
                        accept="image/*"
                        :on-change="handleFileChange"
                    >
                        <img class="send-image" src="@/assets/image/send-image.png" alt="" />
                    </el-upload>
                </div>
                <el-input
                    class="message-input"
                    v-model="message"
                    type="textarea"
                    :rows="2"
                    :bordered="true"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    resize="none"
                    placeholder="请输入内容"
                    @keydown.enter.native.prevent="send"
                />
                <div class="send-btn">
                    <el-button @click="send">发送</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { TIM_NS as TIM } from '@/components/chat/im.js'
// import {copyText, getFileName} from '@/utils/utils'

// import imApi from '@/api/im'
export default {
    name: 'chatComponent',
    data() {
        return {
            message: '',
            userID: '',
            messageList: null,
            shouldScrollToBottom: true,
            customerValue: null,
            // customerListVisible: false,
            userAvatar: '',
            watcher: null, // 存储监听实例
            // dmName: JSON.parse(localStorage.getItem('DM_IM'))?.serverName || ''
            lastMessageTime: sessionStorage.getItem('chatLastMessageTime') ? Number(sessionStorage.getItem('chatLastMessageTime')) : 0, // 从 sessionStorage 读取或初始化为 0
        }
    },
    computed: {
        sortedMessages() {
            return this.$store.state.chat.rightMessageList
        },
        isLoadingMore() {
            return this.$store.state.chat.isLoadingMore
        },
        customerList() {
            return this.$store.state.chat.customerList
        },
        oppositeUserID() {
            return this.$store.state.chat.oppositeUserID
        },
        currentChatId() {
            return this.$store.state.chat.currentChatId
        },
        lastSelectedUserId() {
            return this.$store.state.chat.lastSelectedUserId
        },
        dmName() {
            const customerServiceInfo = this.$store.state.chat.customerServiceInfo
            return customerServiceInfo?.serverName || ''
        },
        chat() {
            return this.$store.state.chat.chat
        },
    },
    created() {},
    mounted() {
        this.scrollToBottom()
        // 监听消息列表变化，自动滚动到底部
        this.$watch(
            () => this.sortedMessages,
            () => {
                if (this.shouldScrollToBottom) {
                    this.scrollToBottom()
                }
            },
            { deep: true }
        )
        this.$nextTick(() => {
            this.getImAccount()
        })
    },
    methods: {
        async checkAndSendTimeMessage() {
            const FIVE_MINUTES = 5 * 60 * 1000 // 5分钟毫秒数
            const currentTime = new Date().getTime()

            // 满足以下任一条件则发送时间消息
            // 1. 有历史消息且超过5分钟
            // 2. 没有历史消息（第一条消息）
            if (this.sortedMessages.length === 0 || (this.sortedMessages.length > 0 && currentTime - this.lastMessageTime > FIVE_MINUTES)) {
                try {
                    // 创建时间消息
                    const timeMessage = this.chat.createCustomMessage({
                        to: this.currentChatId, // 使用正确的当前聊天ID
                        conversationType: TIM.TYPES.CONV_C2C, // 直接使用导入的 TIM 常量
                        payload: {
                            data: JSON.stringify({
                                text: {
                                    out: currentTime / 1000,
                                    in: currentTime / 1000,
                                },
                                type: 'time',
                            }),
                            description: 'time',
                        },
                    })
                    console.log('timeMessage======>', timeMessage)
                    // 发送时间消息
                    await this.chat.sendMessage(timeMessage)
                    // 添加到消息列表
                    this.scrollToBottom()
                } catch (error) {
                    console.error('发送时间消息失败:', error)
                }
            }
            // 更新最后消息时间并保存到 sessionStorage
            this.lastMessageTime = currentTime
            sessionStorage.setItem('chatLastMessageTime', currentTime.toString())
        },
        // 游客获取img
        async getImAccount() {
            this.$store.dispatch('chat/init')
        },
        formatMessageTime(msg) {
            try {
                // 解析时间戳并转换为毫秒级
                const timestamp = Number(JSON.parse(msg.payload.data).text.in)
                return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
            } catch (error) {
                console.error('时间格式化失败:', error)
                return 'Invalid Time'
            }
        },
        // 处理文件消息类型
        getFileType(fileName, fileTypeImg = false) {
            const lastDotIndex = fileName.lastIndexOf('.')
            if (lastDotIndex === -1) {
                return 'unknown'
            }
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
            const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt']
            const fileExtension = fileName.slice(lastDotIndex + 1).toLowerCase()
            if (fileTypeImg) {
                let curType = fileExtension
                switch (fileExtension) {
                    case 'doc':
                        curType = 'docx'
                        break
                    case 'xls':
                        curType = 'xlsx'
                        break
                    case 'ppt':
                        curType = 'pptx'
                        break
                }
                return this.fileTypeMap[curType]
            }

            if (imageExtensions.includes(fileExtension)) {
                return 'image'
            } else if (documentExtensions.includes(fileExtension)) {
                return 'document'
            }
            return 'unknown'
        },
        // 切换聊天窗口显示
        chatModalToggle() {
            this.$store.dispatch('chat/chatModalToggle')
        },
        // 发送消息
        async send() {
            console.log('发送消息', this.$store.state.chat.currentChatId)
            if (this.message && this.currentChatId) {
                // 在发送消息前调用时间检查方法
                await this.checkAndSendTimeMessage()
                await this.$store.dispatch('chat/sendMessage', {
                    text: this.message,
                    toId: this.currentChatId,
                })

                // let oppositeUid = this.currentChatId.replace('DM','')
                // await imApi.imSaveChat({
                //   content: this.message,
                //   oppositeUid: Number(oppositeUid),
                //   oppositeType: 3,
                // });

                this.message = ''
                this.scrollToBottom()
            }
        },
        // 处理滚动事件
        async handleScroll(e) {
            const container = e.target
            if (container.scrollTop === 0 && !this.isLoadingMore) {
                this.shouldScrollToBottom = false
                const oldScrollHeight = container.scrollHeight

                await this.$store.dispatch('chat/getMessage', {
                    conversation: this.currentChatId,
                    loadMore: true,
                })

                this.$nextTick(() => {
                    const newScrollHeight = container.scrollHeight
                    container.scrollTop = newScrollHeight - oldScrollHeight
                })

                this.shouldScrollToBottom = true
            }
        },
        // 验证JSON格式
        isValidJson(str) {
            try {
                JSON.parse(str)
                return true
            } catch (e) {
                return false
            }
        },
        // 处理文件上传
        async handleFileChange(file) {
            // 在发送图片前调用时间检查方法
            await this.checkAndSendTimeMessage()
            this.$store.dispatch('chat/handleFileChange', {
                file,
                toId: this.currentChatId,
            })
        },
        // 滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                if (this.$refs.messageList) {
                    this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
                }
            })
        },
        // 发送客服卡片
        sending() {
            if (this.customerValue) {
                const selectedCustomer = this.customerList.find((item) => item.id === this.customerValue)
                if (selectedCustomer) {
                    this.$store.dispatch('chat/customerServiceCard', {
                        customer: selectedCustomer,
                        toId: this.currentChatId,
                    })
                }
            }
            this.close()
        },
        // 关闭客服选择框
        close() {
            this.customerValue = null
        },
    },
}
</script>

<style scoped lang="scss">
.customer-ele-keFu {
    max-width: 50%;
    color: #5a606b;

    .mune-title {
        line-height: 21px;
        margin-bottom: 8px;
        //overflow: hidden;
        //text-overflow: ellipsis;
        //display: -webkit-box;
        //-webkit-line-clamp: 2;
        //-webkit-box-orient: vertical;
    }

    .menu-list .item2.border {
        border-top: 1px solid #f2f2f2;
    }

    .item2 {
        height: 41px;
        line-height: 40px;
        position: relative;
        cursor: pointer;
    }

    .item2 span {
        display: inline-block;
        max-width: 95%;
    }

    .ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .menu-list .item2:after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-right: 1px solid #a1a6af;
        border-bottom: 1px solid #a1a6af;
        margin-left: 8px;
        transform: rotate(-45deg);
        position: absolute;
        right: 5px;
        top: 18px;
    }

    .menu-list .next:after {
        display: none !important;
    }
}

.img-wrap {
    max-width: 200px;
    max-height: 200px;

    img {
        max-width: 200px;
        max-height: 200px;
        object-fit: cover;
    }
}

.im {
    width: 800px;
    height: 600px;
    position: fixed;
    top: 15%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    display: flex;
    z-index: 1000;
    border-radius: 10px;
    user-select: none;

    ::v-deep .el-select-dropdown__item {
        color: #606266 !important;
        font-weight: 500 !important;
    }

    // 小屏幕适配
    @media screen and (max-width: 768px) {
        width: 95vw;
        max-height: 90vh;
    }

    .user-list {
        width: 280px;
        height: 100%;
        overflow-y: auto;
        border-right: 1px solid #e8e8e8;
        display: flex;
        flex-direction: column;

        .avatar-name {
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 20px;

            &.active {
                background-color: #f0f4f7;
            }

            .avatar-unreadCount {
                position: relative;
                margin-right: 20px;

                .avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }

                .unreadCount {
                    min-height: 20px;
                    min-width: 20px;
                    position: absolute;
                    right: -6px;
                    top: -6px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 2px;
                    background-color: red;
                    color: #fff;
                    font-size: 12px;
                    border-radius: 50%;
                }
            }

            .name-text {
                display: flex;
                flex-direction: column;
                flex: 1;
                gap: 8px 0;

                .nick {
                    width: 80%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }

    .dialogue-content {
        width: 100%;
        padding: 10px;
        padding-top: 45px;
        position: relative;

        .message-list {
            // 滚动条
            overflow-y: auto;
            scrollbar-width: thin;
            scrollbar-color: #c1c1c1 #f0f0f0;

            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }

            &::-webkit-scrollbar-track {
                background: #f0f0f0;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #c1c1c1;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background-color: #a8a8a8;
            }
        }

        .message-list::-webkit-scrollbar {
            display: none;
            /* Chrome/Safari/Webkit */
        }

        .drag-handle {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 40px;
            z-index: 1;
            text-align: center;
            line-height: 40px;
        }

        .close {
            width: 12px;
            height: 12px;
            cursor: pointer;
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 2;
        }

        .message-list {
            height: 320px;
            display: flex;
            flex-direction: column;
            gap: 20px 0;
            overflow-y: scroll;
            padding: 10px;

            .message-item {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                margin: 10px 0;

                .service-avatar {
                    min-width: 252px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 16px;
                    border-radius: 8px;
                    line-height: 22px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #000000;
                    background: #f5faff;

                    img {
                        width: 42px;
                        height: 42px;
                    }
                }

                &.message-left {
                    flex-direction: row-reverse;

                    .text {
                        background: #f5f8fa;
                        order: 1;
                    }

                    .avatar-box {
                        margin-left: 0;
                        margin-right: 10px;
                        order: 2;
                    }
                }

                .image-message {
                    max-width: 200px;
                    border-radius: 8px;
                }

                .avatar-box {
                    margin-left: 10px;

                    .avatar {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                    }
                }

                .text {
                    background: #d1eff2;
                    padding: 12px 16px;
                    border-radius: 12px;
                    word-break: break-all;
                    color: #26282e;
                    line-height: 22px;
                    font-size: 14px;
                    max-width: 70%;
                }

                .image-message {
                    max-width: 200px;
                    max-height: 200px;
                }

                .avatar-box {
                    display: flex;
                    align-items: center;
                    height: 46px;
                    margin-left: 10px;

                    .avatar {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                    }
                }
            }
        }

        .customer-list {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 10;

            .customer-box {
                width: 400px;
                height: 200px;
                background-color: #fff;
                border-radius: 20px;
                padding: 20px;

                .title {
                    margin-bottom: 20px;
                }

                .button-group {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    gap: 20px;
                    margin-top: 40px;

                    .button {
                        width: 100px;
                        height: 40px;
                        font-weight: 400;
                        font-size: 16px;
                        color: #ffffff;
                        text-align: center;
                        line-height: 40px;
                        border-radius: 10px;
                        cursor: pointer;
                    }

                    .sending {
                        background: #1bafbf;
                    }

                    .cancel {
                        background-color: #f6f6f6;
                        color: #1bafbf;
                    }
                }
            }
        }

        .message-box {
            width: 100%;
            text-align: right;
            padding-top: 6px;
            border-top: 10px;
            padding: 20px;
            border-top: 1px solid #e8e8e8;

            .function-bar {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 20px;

                .customer-service {
                    cursor: pointer;
                    width: 24px;
                    height: 24px;
                }
            }

            .send-image {
                width: 26px;
                height: 26px;
            }

            .message-input,
            .message-input ::v-deep .el-textarea__inner:focus {
                border-color: #dcdfe6;
                --el-input-border-color: 'transparent';
                --el-input-hover-border-color: 'transparent';
                box-shadow: none;
            }

            .send-btn {
                width: 100%;
                text-align: right;
                margin-top: 10px;
            }
        }
    }
}
.chat-time-box {
    width: 100%;
    display: unset !important;
    max-width: 100% !important;

    .time-box {
        width: 100%;
        text-align: center;
    }
}

.card-box {
    min-width: 252px;
    padding: 16px;
    background: #f5faff;
    border-radius: 8px;
    //margin-left: 20px;

    .service-avatar {
        display: flex;
        align-items: center;
        gap: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #000000;

        img {
            width: 42px;
            height: 42px;
        }
    }

    .go-chat {
        width: 100%;
        text-align: center;
        margin-top: 12px;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        padding: 5px;
        line-height: 26px;
        background-color: #1bafbf;
        border-radius: 8px;
        cursor: pointer;
    }
}
</style>
